var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"avatar",class:[this.size ? 'avatar-' + this.size : '', this.status ? 'avatar-' + this.status : '']},[(_vm.img)?_c('img',{staticClass:"avatar-img rounded-circle",attrs:{"src":_vm.img}}):_vm._e(),(!_vm.img)?_c('span',{staticClass:"avatar-title rounded-circle text-uppercase"},[_vm._v(_vm._s(_vm.initials))]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }